import { GetInvoiceFileResponse } from 'api/eContractingAPI'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  file: string
} & Status

const initialState: State = {
  file: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_CONTRACT_INVOICE_FILE_ASYNC,
    Actions.GET_CONTRACT_INVOICE_FILE_SUCCESS,
    Actions.GET_CONTRACT_INVOICE_FILE_FAIL,
    GetInvoiceFileResponse
  >,
) => {
  switch (action.type) {
    case Actions.GET_CONTRACT_INVOICE_FILE_SUCCESS:
      return {
        ...action.status,
        file: action.payload.bytes,
      }
    case Actions.GET_CONTRACT_INVOICE_FILE_ASYNC:
    case Actions.GET_CONTRACT_INVOICE_FILE_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
